export default __webpack_public_path__ + "static/sorry-7b74b84899ee25c47a3f509ef723bda8.svg";